export const NODE_TYPE_SDMX = "SDMX-REST";
export const NODE_TYPE_MERGE = "MERGE";
export const NODE_TYPE_CKAN = "Ckan";
export const NODE_TYPE_SPOD = "SpodConnector";
export const NODE_TYPE_DATAPORTAL = "Dataportal";

export const isSdmxNode = node => node?.type === NODE_TYPE_SDMX;
export const isMergeNode = node => node?.type === NODE_TYPE_MERGE;
export const isCkanNode = node => node?.type === NODE_TYPE_CKAN;
export const isSpodNode = node => node?.type === NODE_TYPE_SPOD;
export const isDataportalNode = node => node?.type === NODE_TYPE_DATAPORTAL;
